import { Box, Flex, Text,Input,InputGroup,InputRightAddon,HStack } from "@chakra-ui/react";
import React from "react";
import FormCheckBox from "../../formcontrol/checkbox";
import FormSelect from "../../formcontrol/select";
import { BsCurrencyDollar } from "react-icons/bs";

function ExtraServiceRow({ label }) {
  return (
    <Flex
      borderWidth={"1px"}
      py={2}
      borderRadius={"10px"}
      px={2}
      lineHeight={"normal"}
      justifyContent={"space-between"}
      alignItems={"center"}
      flexDirection={{base:"column",md:"row",lg:"row"}}
    >
      <HStack
       py={{base:"4px"}}
       mb={{base:2}}
       gap={2}
       borderBottomWidth={{base:"1px",md:"0px"}}
       >
      <FormCheckBox />
      <Text
        fontWeight={{lg:"600"}}
        fontSize={{base:"14px", md:"20px"}}
        color="#c5c5c5"
        w="200px"
        align="start"
        overflow={"hidden"}
      >
        {label}
      </Text>

      </HStack>
      <Box display={"flex"} width={{base:"full"}} gap={{base:"2",md:"2"}} justifyContent={{base:"space-evenly"}} alignItems={"center"}>
      <Text
      fontSize={{base:"xx-small",md:"small",lg:"lg"}}
      >For an extra</Text>
      <InputGroup w="fit-content" bg={"rgba(0,141,219,0.11)"}>
                  <Input defaultValue={0} type={"number"} border={"none"} />
                  <InputRightAddon bg={"rgba(0,141,219,0.11)"}>
                    <BsCurrencyDollar />
                  </InputRightAddon>
                </InputGroup>

      <Text fontSize={{base:"xx-small",md:"small",lg:"lg"}} verticalAlign={{md:"center"}}>I'll deliver in</Text>
      <FormSelect
        placeholder={"Select"}
        border={"none"}
        bg={"rgba(0,141,219,0.11)"}
        w={{base:"25%",lg:"200px"}}

      />
      </Box>
           
    </Flex>
  );
}

export default ExtraServiceRow;
